import { createComponent, ElementWithProps } from '@carvana/merch-components';
import cx from 'classnames';

function generateIconUrl(iconType?: 'primary' | 'secondary' | 'hover') {
  const baseUrl = `${process.env.CVNA_APP_CDN_ASSETS_PATH}/svgs`;

  switch (iconType) {
    case 'primary':
      return `url(${baseUrl}/anchor_icon_primary.svg)`;
    case 'secondary':
      return `url(${baseUrl}/anchor_icon_secondary.svg)`;
    case 'hover':
      return `url(${baseUrl}/anchor_icon_hover.svg)`;
    default:
      return undefined;
  }
}

export type AnchorProps = ElementWithProps<
  {
    icon?: 'before' | 'after';
    iconType?: 'primary' | 'secondary';
  },
  HTMLAnchorElement
>;

export const BaseAnchor = createComponent<AnchorProps>('a', props => ({
  className: cx({
    'inline-flex gap-md': props.icon,
    'before:h-[14px] before:w-[14px] before:content-[var(--anchor-icon)] before:hover:content-[var(--anchor-icon-hover)]':
      props.icon === 'before',
    'after:h-[14px] after:w-[14px] after:content-[var(--anchor-icon)] after:hover:content-[var(--anchor-icon-hover)]':
      props.icon === 'after'
  }),
  style: props.icon
    ? {
        '--anchor-icon': generateIconUrl(props.iconType),
        '--anchor-icon-hover': generateIconUrl(props.icon ? 'hover' : undefined)
      }
    : undefined
}));

export const PrimaryAnchor = createComponent<AnchorProps>(BaseAnchor, {
  className:
    'text-text-primary hover:text-text-primary-hover active:text-text-primary-active -:no-underline',
  iconType: 'primary'
});

export const SecondaryAnchor = createComponent<AnchorProps>(BaseAnchor, {
  className:
    'text-text-default hover:text-text-primary-hover active:text-text-primary-active -:no-underline',
  iconType: 'secondary'
});

export const CurrentAnchor = createComponent<AnchorProps>(BaseAnchor, {
  className: 'text-current -:no-underline'
});

export const PrimaryInlineAnchor = createComponent<AnchorProps>(PrimaryAnchor, {
  className: 'underline'
});

export const SecondaryInlineAnchor = createComponent<AnchorProps>(
  SecondaryAnchor,
  {
    className: 'underline'
  }
);

export const CurrentInlineAnchor = createComponent<AnchorProps>(CurrentAnchor, {
  className: 'underline'
});
